"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-thirteen/sections/headerSection.tsx */

import { LandingSiteTemplateGetDataMenuOutputApiModel } from "@/Apis/ClinicApi";
import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import HeaderNav from "../../Components/HeaderNav";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode, MouseEventHandler } from "react";

type HeaderSectionSelectsItem = {
    key: Key | null | undefined;
    /** Detected variants: "New York" | "Chicago" | "San Diego" | "Dallas" | "Miami" */
    optionText: ReactNode;
};

type HeaderSectionSelects2Item = {
    key: Key | null | undefined;
    /** Detected variants: "All Catgeories" | "Liver Care" | "Dental Care" | "Orthopedic" | "Kidney Care" | "Cardiac Care" */
    optionText: ReactNode;
};

type HeaderSectionUlsItem = {
    key: Key | null | undefined;
    /** Detected variants: "all_routes.cart" | "#" */
    href: string;
    /** Detected variants: "isax isax-shopping-cart" | "isax isax-heart" */
    className: string;
    /** Detected variants: "header-icon" */
    link0ClassName?: string;
    /** Detected variants: "badge" */
    span0ClassName?: string;
};

type HeaderSectionUls2Item = {
    key: Key | null | undefined;
    /** Detected variants: "header-icon" | "btn-primary menu-toggle" */
    className: string;
    /** Detected variants: "#pharmacy_menu" */
    dataBsTarget?: string;
    /** Detected variants: "offcanvas" */
    dataBsToggle?: string;
    /** Detected variants: "all_routes.pharmacyRegister" | "#" */
    href: string;
    /** Detected variants: "isax isax-user" | "isax isax-menu-1" */
    i0ClassName: string;
};
export type HomeThirteenHeaderSectionGeneratedProps = {
    menus: LandingSiteTemplateGetDataMenuOutputApiModel[];
    isScrolled?: boolean;
    onMobileBtn?: MouseEventHandler<HTMLAnchorElement>;
    onMenuClose?: MouseEventHandler<HTMLAnchorElement>;
    /** Default: "Select Location" */
    headerDiv0Nav0Div0Div0P0PText?: ReactNode;
    /** Default: "#" */
    headerDiv0Nav0Div0Link0LinkHref?: string;
    /** Default: "mobile_btn" */
    headerDiv0Nav0Div0Link0LinkId?: string;
    headerDiv0Nav0Div0Link0LinkVisible?: boolean;
    headerDiv0Nav0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "all_routes.home13" */
    headerDiv0Nav0Div0Link1LinkHref?: string;
    headerDiv0Nav0Div0Link1LinkVisible?: boolean;
    headerDiv0Nav0Div0Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div0Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Logo" */
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/logo-13.svg" */
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageSrc?: string;
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageVisible?: boolean;
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "all_routes.home13" */
    headerDiv0Nav0Div1Div0Link0LinkHref?: string;
    headerDiv0Nav0Div1Div0Link0LinkVisible?: boolean;
    headerDiv0Nav0Div1Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div1Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Logo" */
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/logo-13.svg" */
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageSrc?: string;
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageVisible?: boolean;
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "#" */
    headerDiv0Nav0Div1Div0Link1LinkHref?: string;
    /** Default: "menu_close" */
    headerDiv0Nav0Div1Div0Link1LinkId?: string;
    headerDiv0Nav0Div1Div0Link1LinkVisible?: boolean;
    headerDiv0Nav0Div1Div0Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div1Div0Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "all_routes.home" */
    headerDiv0Nav0Div1Div1Div0Link0LinkHref?: string;
    headerDiv0Nav0Div1Div1Div0Link0LinkVisible?: boolean;
    headerDiv0Nav0Div1Div1Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div1Div1Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    headerDiv0Nav0Div1Div1Div1Button0ButtonVisible?: boolean;
    headerDiv0Nav0Div1Div1Div1Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div1Div1Div1Button0ButtonProps?: Partial<ComponentProps<"button">>;
    /** Default: "Search Medecine, Phramacy" */
    headerDiv0Nav0Div1Div1Div1Input0InputPlaceholder?: string;
    headerDiv0Nav0Ul0Li3Link0LinkVisible?: boolean;
    headerDiv0Nav0Ul0Li3Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Ul0Li3Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    liLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: HeaderSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
    headerSectionSelects: HeaderSectionSelectsItem[];
    headerSectionSelects2: HeaderSectionSelects2Item[];
    headerSectionUls: HeaderSectionUlsItem[];
    headerSectionUls2: HeaderSectionUls2Item[];
    headerSectionSelectsItemWrapper?: (item: HeaderSectionSelectsItem, content: ReactNode) => ReactNode;
    headerSectionSelectsRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerSectionSelects2ItemWrapper?: (item: HeaderSectionSelects2Item, content: ReactNode) => ReactNode;
    headerSectionSelects2Renderer?: (defaultNode: ReactNode) => ReactNode;
    headerSectionUlsItemWrapper?: (item: HeaderSectionUlsItem, content: ReactNode) => ReactNode;
    headerSectionUlsRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerSectionUlsLinkVisible?: boolean;
    headerSectionUlsLinkRenderer?: (item: HeaderSectionUlsItem, defaultNode: ReactNode) => ReactNode;
    headerSectionUlsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: HeaderSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
    headerSectionUls2ItemWrapper?: (item: HeaderSectionUls2Item, content: ReactNode) => ReactNode;
    headerSectionUls2Renderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeThirteenHeaderSectionGenerated: FC<HomeThirteenHeaderSectionGeneratedProps> = ({
    menus,
    isScrolled,
    onMobileBtn,
    onMenuClose,
    headerDiv0Nav0Div0Div0P0PText = "Select Location",
    headerDiv0Nav0Div0Link0LinkHref = "#",
    headerDiv0Nav0Div0Link0LinkId = "mobile_btn",
    headerDiv0Nav0Div0Link0LinkVisible,
    headerDiv0Nav0Div0Link0LinkRenderer,
    headerDiv0Nav0Div0Link0LinkProps,
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageAlt = "Logo",
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/logo-13.svg",
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageVisible,
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageRenderer,
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageProps,
    headerDiv0Nav0Div0Link1LinkHref = "all_routes.home13",
    headerDiv0Nav0Div0Link1LinkVisible,
    headerDiv0Nav0Div0Link1LinkRenderer,
    headerDiv0Nav0Div0Link1LinkProps,
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageAlt = "Logo",
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/logo-13.svg",
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageVisible,
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageRenderer,
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageProps,
    headerDiv0Nav0Div1Div0Link0LinkHref = "all_routes.home13",
    headerDiv0Nav0Div1Div0Link0LinkVisible,
    headerDiv0Nav0Div1Div0Link0LinkRenderer,
    headerDiv0Nav0Div1Div0Link0LinkProps,
    headerDiv0Nav0Div1Div0Link1LinkHref = "#",
    headerDiv0Nav0Div1Div0Link1LinkId = "menu_close",
    headerDiv0Nav0Div1Div0Link1LinkVisible,
    headerDiv0Nav0Div1Div0Link1LinkRenderer,
    headerDiv0Nav0Div1Div0Link1LinkProps,
    headerDiv0Nav0Div1Div1Div0Link0LinkHref = "all_routes.home",
    headerDiv0Nav0Div1Div1Div0Link0LinkVisible,
    headerDiv0Nav0Div1Div1Div0Link0LinkRenderer,
    headerDiv0Nav0Div1Div1Div0Link0LinkProps,
    headerDiv0Nav0Div1Div1Div1Input0InputPlaceholder = "Search Medecine, Phramacy",
    headerDiv0Nav0Div1Div1Div1Button0ButtonVisible,
    headerDiv0Nav0Div1Div1Div1Button0ButtonRenderer,
    headerDiv0Nav0Div1Div1Div1Button0ButtonProps,
    headerDiv0Nav0Ul0Li3Link0LinkVisible,
    headerDiv0Nav0Ul0Li3Link0LinkRenderer,
    headerDiv0Nav0Ul0Li3Link0LinkProps,
    liLink0LinkProps,
    headerSectionSelects,
    headerSectionSelects2,
    headerSectionUls,
    headerSectionUls2,
    headerSectionSelectsItemWrapper,
    headerSectionSelectsRenderer,
    headerSectionSelects2ItemWrapper,
    headerSectionSelects2Renderer,
    headerSectionUlsItemWrapper,
    headerSectionUlsRenderer,
    headerSectionUlsLinkVisible,
    headerSectionUlsLinkRenderer,
    headerSectionUlsLinkProps,
    headerSectionUls2ItemWrapper,
    headerSectionUls2Renderer,
}) => {
    return (
        <>
            <header className={isScrolled ? "header header-thirteen home-menu fixed" : "header header-thirteen home-menu"}>
                <div className="container-fluid">
                    <nav className="navbar navbar-expand-lg header-nav">
                        <div className="navbar-header">
                            {renderNode(headerDiv0Nav0Div0Link0LinkVisible, headerDiv0Nav0Div0Link0LinkRenderer, (
                                <SmartLink id={headerDiv0Nav0Div0Link0LinkId} href={headerDiv0Nav0Div0Link0LinkHref} onClick={onMobileBtn} {...(headerDiv0Nav0Div0Link0LinkProps ?? {})}>
                                    <i className="fa-solid fa-bars" />
                                </SmartLink>
                            ))}
                            {renderNode(headerDiv0Nav0Div0Link1LinkVisible, headerDiv0Nav0Div0Link1LinkRenderer, (
                                <SmartLink href={headerDiv0Nav0Div0Link1LinkHref} className="navbar-brand logo" {...(headerDiv0Nav0Div0Link1LinkProps ?? {})}>
                                    {renderNode(headerDiv0Nav0Div0Link1ImageWithBasePath0ImageVisible, headerDiv0Nav0Div0Link1ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={headerDiv0Nav0Div0Link1ImageWithBasePath0ImageSrc} className="img-fluid normal-logo" alt={headerDiv0Nav0Div0Link1ImageWithBasePath0ImageAlt} {...(headerDiv0Nav0Div0Link1ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                </SmartLink>
                            ))}
                            <div className="location-dropdown">
                                <p>
                                    <i className="isax isax-location me-1" />
                                    {headerDiv0Nav0Div0Div0P0PText}
                                </p>
                                <select>
                                    {renderCollectionNode(
                                        headerSectionSelects,
                                        (item: HeaderSectionSelectsItem) => (
                                            <option key={item.key}>{item.optionText}</option>
                                        ),
                                        headerSectionSelectsItemWrapper,
                                        headerSectionSelectsRenderer
                                    )}
                                </select>
                            </div>
                        </div>
                        <div className="main-menu-wrapper">
                            <div className="menu-header">
                                {renderNode(headerDiv0Nav0Div1Div0Link0LinkVisible, headerDiv0Nav0Div1Div0Link0LinkRenderer, (
                                    <SmartLink href={headerDiv0Nav0Div1Div0Link0LinkHref} className="menu-logo" {...(headerDiv0Nav0Div1Div0Link0LinkProps ?? {})}>
                                        {renderNode(headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageVisible, headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageRenderer, (
                                            <SmartImage src={headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageSrc} className="img-fluid" alt={headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageAlt} {...(headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageProps ?? {})} />
                                        ))}
                                    </SmartLink>
                                ))}
                                {renderNode(headerDiv0Nav0Div1Div0Link1LinkVisible, headerDiv0Nav0Div1Div0Link1LinkRenderer, (
                                    <SmartLink id={headerDiv0Nav0Div1Div0Link1LinkId} className="menu-close" href={headerDiv0Nav0Div1Div0Link1LinkHref} onClick={onMenuClose} {...(headerDiv0Nav0Div1Div0Link1LinkProps ?? {})}>
                                        <i className="fas fa-times" />
                                    </SmartLink>
                                ))}
                            </div>
                            <HeaderNav menus={menus} />
                            <div className="search-item">
                                <div className="home-icon">
                                    {renderNode(headerDiv0Nav0Div1Div1Div0Link0LinkVisible, headerDiv0Nav0Div1Div1Div0Link0LinkRenderer, (
                                        <SmartLink href={headerDiv0Nav0Div1Div1Div0Link0LinkHref} {...(headerDiv0Nav0Div1Div1Div0Link0LinkProps ?? {})}>
                                            <i className="isax isax-home-2" />
                                        </SmartLink>
                                    ))}
                                </div>
                                <div className="header-search">
                                    <select>
                                        {renderCollectionNode(
                                            headerSectionSelects2,
                                            (item: HeaderSectionSelects2Item) => (
                                                <option key={item.key}>{item.optionText}</option>
                                            ),
                                            headerSectionSelects2ItemWrapper,
                                            headerSectionSelects2Renderer
                                        )}
                                    </select>
                                    <input type="text" placeholder={headerDiv0Nav0Div1Div1Div1Input0InputPlaceholder} className="form-control" />
                                    {renderNode(headerDiv0Nav0Div1Div1Div1Button0ButtonVisible, headerDiv0Nav0Div1Div1Div1Button0ButtonRenderer, (
                                        <button className="search-icon btn btn-primary" {...(headerDiv0Nav0Div1Div1Div1Button0ButtonProps ?? {})}>
                                            <i className="isax isax-search-normal-1" />
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <ul className="nav header-navbar-rht">
                            {renderCollectionNode(
                                headerSectionUls,
                                (item: HeaderSectionUlsItem) => (
                                    <li key={item.key}>
                                        {renderItemNode(headerSectionUlsLinkVisible, headerSectionUlsLinkRenderer, item, (
                                            <SmartLink href={item.href} className={item.link0ClassName ?? "header-icon"} {...(typeof headerSectionUlsLinkProps === "function" ? headerSectionUlsLinkProps(item) : (headerSectionUlsLinkProps ?? {}))} {...(typeof liLink0LinkProps === "function" ? liLink0LinkProps(item) : (liLink0LinkProps ?? {}))}>
                                                <i className={item.className} />
                                                <span className={item.span0ClassName ?? "badge"} />
                                            </SmartLink>
                                        ))}
                                    </li>
                                ),
                                headerSectionUlsItemWrapper,
                                headerSectionUlsRenderer
                            )}
                            <li>
                                {renderNode(headerDiv0Nav0Ul0Li3Link0LinkVisible, headerDiv0Nav0Ul0Li3Link0LinkRenderer, (
                                    <SmartLink href="#" data-bs-toggle="offcanvas" data-bs-target="#pharmacy_menu" className="btn-primary menu-toggle" {...(headerDiv0Nav0Ul0Li3Link0LinkProps ?? {})}>
                                        <i className="isax isax-menu-1" />
                                    </SmartLink>
                                ))}
                            </li>
                        </ul>
                    </nav>
                </div>
            </header>
            <div data-template-tag="HeaderOffcanvas" />
        </>
    );
};

export default HomeThirteenHeaderSectionGenerated;
